module.exports = __webpack_public_path__ + "img/Bulgaria.836b998a.svg";